import React, {useState} from 'react';
import FormInput from '../../../props/propertyFormProp';
import { patchDataRaw } from '../../../fetchRoutes/patchDataRaw';


export default function UpdateAuctionForm({auction, onClose}){

    const updateAuction = process.env.REACT_APP_GET_AN_AUCTION;

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const [formData, setFormData] = useState({
        endTime: "",
        increment: "",
        reservePrice: ""
    });

    const [fieldErrors, setFieldErrors] = useState({});

    // Handle form field changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

        // Clear validation errors in real-time
        validateField(name, value);
    };
    
    const validateField = (name, value) => {
        const errors = { ...fieldErrors };
        
        // End date validation: must be at least day after tomorrow
        if (name === "endTime") {
            const end = new Date(value);
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 2); // Move to day after tomorrow
            tomorrow.setHours(0, 0, 0, 0);

            if (end < tomorrow) {
                errors.endTime = "End time must be at 2 days from today.";
            } else {
                delete errors.endTime; 
            }
        }

        // Increment validation
        if (name === "increment") {
            const increment = parseInt(value, 10);
            if (isNaN(increment) || increment <= 0) {
                errors.increment = "Increment must be greater than 0.";
            } else if (increment % 1000 !== 0) {
                errors.increment = "Increment must be in thousands.";
            } else {
                delete errors.increment;  // Clear error
            }
        }

        // Reserve price validation
        if (name === "reservePrice") {
            const reservePrice = parseInt(value, 10);
            if (isNaN(reservePrice) || reservePrice <= 0) {
                errors.reservePrice = "Reserve price must be greater than 0.";
            } else if (reservePrice % 1000 !== 0) {
                errors.reservePrice = "Reserve price must be in thousands.";
            } else {
                delete errors.reservePrice;  // Clear error
            }
        }

        setFieldErrors(errors);
    };

    // Form submissiom
    const handleSubmit = async (event)=>{
        event.preventDefault();
        setIsLoading(true);

        try{
            
            const url = `${updateAuction}/${auction._id}/update`;

            const response = await patchDataRaw(url, formData);

            if(response.status === 'Success'){
                onClose();
            }

        } catch(error){
            setError("An error occurred.");
            setIsLoading(false);

        }finally{
            setIsLoading(false);

        }
    }

    return (
        <div className="updateProperty updateAuction">
            {isLoading && (
                <div className="loaderContainer">
                    <div className="loader"></div>
                    <p className="loadingText">Updating your auction details...</p>
                </div>
            )}

            <div className="updateAuctionProp">
                <div className="formTitle">
                    <h1 className="addTitle">Update Auction</h1>
                    <div className="underline"></div>                      
                </div>

                <form className='addPropertyForm' onSubmit={handleSubmit}> 
                    
                    <FormInput 
                        label="Reserve Price" 
                        name="reservePrice" 
                        type="number" 
                        placeholder="Entter the reserve price" 
                        required={false}
                        astriskClass="hideMe"
                        className={`updateMe ${fieldErrors.reservePrice ? "error" : ""}`}
                        divClass="update"
                        value={formData.reservePrice}
                        onChange={handleChange}
                        errorMessage={fieldErrors.reservePrice} 
                    />

                    <FormInput 
                        label="Increment" 
                        name="increment" 
                        type="number" 
                        placeholder="Entter the increment value" 
                        required={false}
                        astriskClass="hideMe"
                        className={`updateMe ${fieldErrors.increment ? "error" : ""}`}
                        divClass="update"
                        value={formData.increment}
                        onChange={handleChange}
                        errorMessage={fieldErrors.increment} 
                    />

                    <FormInput 
                        label="End Date:" 
                        name="endTime" 
                        type="datetime-local" 
                        placeholder="Entter the ending date" 
                        required={false}
                        astriskClass="hideMe"
                        className={`updateMe ${fieldErrors.endTime ? "error" : ""}`}
                        divClass="update"
                        value={formData.endTime}
                        onChange={handleChange}
                        errorMessage={fieldErrors.endTime} 
                    />


                    <div className="formButtons">
                        <button type="button" className="cancelAuction" onClick={onClose}>Cancel</button>
                        <button type="submit" className="submitPropertyButton submitUpdateProperty">
                            Update
                        </button>
                    </div>

                </form>

                {error && (
                    <div className="errorMessage">
                        <span className="error">{error}</span>
                    </div>
                )}
            </div>
        </div>
    )

}